import '../styles/main.scss';

import naja from 'naja';
import netteForms from 'nette-forms';

import onDomReady from './onDomReady';

window.Nette = netteForms;
netteForms.initOnLoad();

naja.initialize();

naja.addEventListener('start', () => {
	document.body.classList.add('is-loading');
});

naja.addEventListener('complete', () => {
	document.body.classList.remove('is-loading');
});

const loadOnce = loader => {
	let loaded = false;
	return () => {
		if (loaded) {
			return;
		}
		loaded = true;
		loader().catch(() => {
			loaded = false;
		});
	};
};

const loadMainMenu = loadOnce(() => import('./components/main-menu'));
const loadMainMenuDropdown = loadOnce(
	() => import('./components/main-menu__dropdown'),
);
const loadLazyLoad = loadOnce(() => import('./components/lazy-load'));
const loadFaq = loadOnce(() => import('./components/faq'));
const loadOembed = loadOnce(() => import('./components/oembed'));
const loadLightbox = loadOnce(() =>
	import('glightbox').then(({ default: GLightbox }) => {
		window.GLightbox = new GLightbox({
			touchNavigation: true,
		});
	}),
);

const bootstrapConditionalModules = () => {
	if (document.getElementById('masthead')) {
		loadMainMenu();
	}

	if (document.getElementById('dropdownMenuButton')) {
		loadMainMenuDropdown();
	}

	if (document.querySelector('.lazy')) {
		loadLazyLoad();
	}

	if (document.querySelector('.faq-question')) {
		loadFaq();
	}

	if (document.querySelector('oembed')) {
		loadOembed();
	}

	if (document.querySelector('.glightbox')) {
		loadLightbox();
	}
};

const initParallax = () => {
	const parallaxElements = Array.from(document.querySelectorAll('.parallax'));
	if (!parallaxElements.length) {
		return;
	}

	const updateParallax = el => {
		const img = el.querySelector('.parallax-img');
		if (!img) {
			return;
		}
		const parallaxStart = el.offsetTop;
		const windowHeight = window.innerHeight;
		const scrolledY = window.scrollY;

		if (scrolledY + windowHeight > parallaxStart) {
			const parallaxOffset = scrolledY - parallaxStart;
			img.style.transform = `translateY(${parallaxOffset * 0.5}px)`;
		}
	};

	const refresh = () => {
		parallaxElements.forEach(updateParallax);
	};

	refresh();
	document.addEventListener('scroll', refresh, { passive: true });
};

const initAnchorScrolling = () => {
	const links = document.querySelectorAll('a[href^="#"]:not(.not-anchor)');
	if (!links.length) {
		return;
	}

	const slideToElement = hash => {
		const targetId = hash.replace('#', '');
		const targetElement = document.getElementById(targetId);
		const masthead = document.getElementById('masthead');

		if (!targetElement || !masthead) {
			return;
		}

		const mastheadHeight = masthead.clientHeight;
		const elementPosition =
			targetElement.getBoundingClientRect().top + window.pageYOffset;
		const offsetPosition = elementPosition - mastheadHeight;

		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth',
		});
	};

	links.forEach(link => {
		link.addEventListener('click', event => {
			if (!link.hash) {
				return;
			}
			slideToElement(link.hash);
			event.preventDefault();
		});
	});
};

const initHeroSubtitleNbsp = () => {
	document.querySelectorAll('.hero-subtitle').forEach(el => {
		el.innerHTML = el.textContent.replace(
			/(.+)\s+(\S+)\s+(\S+)$/,
			'$1\u00A0$2\u00A0$3',
		);
	});
};

const initRequiredMarkers = () => {
	document.querySelectorAll('input[required]').forEach(input => {
		const id = input.id;
		if (!id) {
			return;
		}
		const label = document.querySelector(`label[for="${id}"]`);
		if (label && !label.querySelector('.required-mark')) {
			label.insertAdjacentHTML(
				'beforeend',
				' <span class="required-mark" style="color: #ff0066;">*</span>',
			);
		}
	});
};

const initPasswordToggles = () => {
	document.querySelectorAll('input[type=password]').forEach(el => {
		if (!el.nextElementSibling?.classList?.contains('input-password-eye')) {
			el.parentElement.style.position = 'relative';
			el.insertAdjacentHTML(
				'afterend',
				'<span class="input-password-eye"></span>',
			);
		}
	});

	document.querySelectorAll('.input-password-eye').forEach(el => {
		if (el.dataset.bound === '1') {
			return;
		}
		el.dataset.bound = '1';
		el.addEventListener('click', event => {
			const input = event.target.previousElementSibling;
			if (!input) {
				return;
			}
			input.type = input.type === 'password' ? 'text' : 'password';
		});
	});
};

const loadPhoneValidator = loadOnce(async () => {
	const { default: PhoneNumberParser } = await import(
		'./components/phoneValidator'
	);

	document.querySelectorAll('.phone-validator').forEach(el => {
		if (el.dataset.phoneValidatorBound === '1') {
			return;
		}
		const form = el.closest('form');
		const phoneInput = el.getAttribute('id');
		if (!form || !phoneInput) {
			return;
		}

		const parser = new PhoneNumberParser(form, phoneInput);
		form.addEventListener('submit', parser.handleSubmit.bind(parser));
		el.addEventListener('input', parser.handleCheck.bind(parser));
		el.dataset.phoneValidatorBound = '1';
	});
});

const bootstrapFormEnhancements = () => {
	initRequiredMarkers();
	initPasswordToggles();

	if (document.querySelector('.phone-validator')) {
		loadPhoneValidator();
	}
};

onDomReady(() => {
	bootstrapConditionalModules();
	initParallax();
	initAnchorScrolling();
	initHeroSubtitleNbsp();
	bootstrapFormEnhancements();
});

naja.addEventListener('complete', () => {
	bootstrapConditionalModules();
	bootstrapFormEnhancements();
});
